import { jsxs, jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { Box, Tabs } from "@zillow/constellation-10";
import { omitUndefined } from "../../utils/lodash.esm.js";
import CalculatorForm from "../CalculatorForm/CalculatorForm.esm.js";
import { FieldConfig } from "./AffordabilityCalculator.utils.esm.js";
import AffordabilityChart from "./AffordabilityChart.esm.js";
import AffordabilityFields from "./AffordabilityFields.esm.js";
import AffordabilityVisual from "./AffordabilityVisual/AffordabilityVisual.esm.js";
import FullReportButton from "./FullReportButton.esm.js";
const AFFORDABILITY_CALCULATOR_KEYS = Object.keys(FieldConfig);
const calculatorFormStyles = css({
  paddingBottom: "md",
  display: "flex",
  flexDirection: "column-reverse",
  lg: {
    flexDirection: "row",
    justifyContent: "space-between"
  }
});
const fieldsStyles = css({
  flexShrink: 0,
  md: {
    flexBasis: "30%"
  },
  lg: {
    marginRight: "md"
  }
});
const AffordabilityCalculator = ({
  defaultValues,
  editorMode
}) => /* @__PURE__ */ jsxs(CalculatorForm, { className: calculatorFormStyles, editorMode, fieldStorageKey: "affordabilityFields", calcTypeForMarketing: "Affordability", defaultValues: {
  [FieldConfig.customPayment.name]: false,
  [FieldConfig.maximumPayment.name]: 3500,
  [FieldConfig.annualIncome.name]: 7e4,
  [FieldConfig.monthlyDebts.name]: 250,
  [FieldConfig.downPayment.name]: 2e4,
  [FieldConfig.dti.name]: 36,
  [FieldConfig.rate.name]: 5,
  [FieldConfig.term.name]: 360,
  [FieldConfig.includePMI.name]: true,
  [FieldConfig.includeTaxesInsurance.name]: true,
  [FieldConfig.propertyTaxRate.name]: 1.2,
  [FieldConfig.annualHomeownersInsurance.name]: 945,
  [FieldConfig.monthlyHOA.name]: 0,
  [FieldConfig.monthlyPayment.name]: 1850,
  ...omitUndefined(defaultValues)
}, children: [
  /* @__PURE__ */ jsx(AffordabilityFields, { className: fieldsStyles }),
  /* @__PURE__ */ jsxs(Box, { css: {
    position: "relative",
    md: {
      flexBasis: "65%"
    }
  }, children: [
    /* @__PURE__ */ jsxs(Tabs.Root, { defaultSelected: "home-price", children: [
      /* @__PURE__ */ jsxs(Tabs.List, { "aria-label": "Affordability calculator tabs", children: [
        /* @__PURE__ */ jsx(Tabs.Tab, { type: "button", value: "home-price", children: "Home price" }),
        /* @__PURE__ */ jsx(Tabs.Tab, { type: "button", value: "payment", children: "Payment" })
      ] }),
      /* @__PURE__ */ jsx(Tabs.Panel, { value: "home-price", children: /* @__PURE__ */ jsx(AffordabilityVisual, {}) }),
      /* @__PURE__ */ jsx(Tabs.Panel, { value: "payment", children: /* @__PURE__ */ jsx(AffordabilityChart, {}) })
    ] }),
    /* @__PURE__ */ jsx(FullReportButton, {})
  ] })
] });
export {
  AFFORDABILITY_CALCULATOR_KEYS,
  AffordabilityCalculator as default
};
